<template>
  <div class="orders">
    <SidebarAccount />
    <div class="allOrders">
      <h2 class="allOrders__title">Meus Pedidos</h2>
      <OrderHideShow />
    </div>
  </div>
</template>

<script>
import SidebarAccount from "../../account/SidebarAccount";
import OrderHideShow from "../OrderHideShow";
export default {
  components: {
    SidebarAccount,
    OrderHideShow,
  },
};
</script>

<style lang="scss" scoped>
.orders {
  max-width: 100%;
  margin: 0 auto;
  padding-top: 60px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  @media (min-width: 441px) and (max-width: 1024px) {
    max-width: 90%;
    flex-direction: row;
  }

  @media (min-width: 1025px) and (max-width: 1919px) {
    max-width: 85%;
    flex-direction: row;
  }

  @media (min-width: 1920px) {
    max-width: 65%;
    flex-direction: row;
  }

  .allOrders {
    width: 100%;

    @media (min-width: 441px) and (max-width: 768px) {
      width: 70%;
    }

    @media (min-width: 769px) {
      width: 80%;
    }

    &__title {
      color: var(--customGray-500);
      font-size: 1.5rem;
      padding: 20px;

      @media (min-width: 441px) {
        padding: 0 0 0 20px;
      }
    }
  }
}
</style>